import ConstructionAmountCalculator from "./ConstructionAmountCalculator";

export default new ConstructionAmountCalculator();
